export function shareOnline(link, siteName) {
  let url = encodeURIComponent(link); // Replace with your product page URL
  if (siteName === "facebook")
    url = "https://www.facebook.com/sharer/sharer.php?u=" + url;
  else if (siteName === "twitter")
    url = "https://twitter.com/intent/tweet?url=" + url;
  else if (siteName === "linkedin")
    url = "https://www.linkedin.com/sharing/share-offsite/?url=" + url;
  else return;
  window.open(url, "_blank");
}

// check if the object is empty
export const isObjEmpty = (obj) => {
  if (obj) return Object.keys(obj).length === 0;
  else return false;
};

// included in string or not
export const isIncluded = (str = "", pattern = "") => {
  return str.toLowerCase().includes(pattern.toLowerCase());
};

// string to link converter feature functions
export const nameToLinkConverter = (name) => {
  return name.toLowerCase().replace(/\s+/g, "-");
};

// popular product extraction
export const extractPopularProduct = (products) => {
  return products.filter((item) => item.isPopular);
};

// make string upperCase
export const capitalize = (string) => {
  return string[0].toUpperCase() + string.slice(1, string.length).toLowerCase();
};

// to copy String
export const clickToCopy = (string = "") => {
  return navigator.clipboard.writeText(string);
};
